/**
 * Creates a function to attach click handlers to an element. To conform with the Client Event
 * Schema specifications, the handler will ensure that both a left and right (context menu) click
 * will track click events.
 * @param {Function} handler - A function handler to (presumably) send a client event on click. An
 * object containing required layers for the click event as well as the original Event will always be passed as the first
 * argument of the handler.
 * @return {Function} - A function to attach the handler to a DOM element
 */
var click = (handler =>
/**
 * This attaches left and right click handler to a specified element.
 * @param {HTMLElement} element - DOM element to attach event listeners to
 * @param {...Any} additional_args - An unspecified number of arguments to pass back to the provided event handler
 * @return {Function} - A function to remove any attached event listeners
 */
function (element) {
  for (var _len = arguments.length, additional_args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    additional_args[_key - 1] = arguments[_key];
  }
  const onClick = event => {
    handler({
      event,
      layers: [{
        click_type: 'left'
      }]
    }, ...additional_args);
  };
  const onContextMenu = event => {
    handler({
      event,
      layers: [{
        click_type: 'right'
      }]
    }, ...additional_args);
  };
  element.addEventListener('click', onClick);
  element.addEventListener('contextmenu', onContextMenu);
  return () => {
    element.removeEventListener('click', onClick);
    element.removeEventListener('contextmenu', onContextMenu);
  };
});

export default click;
